export default {
    data() {
        return {
            textDialogError: '',
            primaryAction: {
                label: this.$t.__('common.actions.verify'),
                action: () => {
                    this.onVerify();
                },
            },
            secondaryActions: [
                {
                    label: this.$t.__('email.emailPanels.EmailPanel.send_my_mail'),
                    action: () => {
                        this.OnSendEmailWithoutVerify();
                    },
                },
            ],
            needOneMainRecipient: true,
            shouldDisplayErrorDialog: false,
            shouldDisplayEmptyRecipientsWarningDialog: false,
            primaryActionEmptyRecipientsWarningDialog: {
                label: this.$t.__('common.actions.send'),
                action: () => {
                    this.needOneMainRecipient = false;
                    this.shouldDisplayEmptyRecipientsWarningDialog = false;
                    this.sendEmail();
                },
            },
            secondaryActionsEmptyRecipientsWarningDialog: [
                {
                    label: this.$t.__('common.actions.cancel'),
                    action: () => {
                        this.shouldDisplayEmptyRecipientsWarningDialog = false;
                    },
                },
            ],
            emptyRecipientsWarningDialogText: this.$t.__(
                'email.emailPanels.EmailPanel.empty_recipients_warning_dialog.confirm_text',
                {
                    startStrong: '<span class="typographies-paragraph-medium-bold">',
                    endStrong: '</span>',
                },
            ),
        };
    },
    methods: {
        onVerify() {
            this.shouldDisplayErrorDialog = false;
        },
        OnSendEmailWithoutVerify() {
            this.shouldDisplayErrorDialog = false;
            this.email.addresses = this.email.addresses.filter((item) => item.isValid);
            this.sendEmail();
        },
        getLabelInput(type) {
            switch (type) {
                case 'cc':
                    return this.$l10n.__('Cc');
                case 'bcc':
                    return this.$l10n.__('Cci');
                default:
                    return this.$l10n.__('À');
            }
        },
        updateTextContent(numberInvalidEmailsAddresses, emailsRecipientsTypeInvalid) {
            const labels = emailsRecipientsTypeInvalid.map((t) => this.getLabelInput(t));

            const formatLabels = (arr) => {
                if (arr.length === 1) return arr[0];
                if (arr.length === 2) return `${arr[0]} et ${arr[1]}`;
                return `${arr.slice(0, -1).join(', ')} et ${arr[arr.length - 1]}`;
            };

            const formattedLabels = formatLabels(labels);

            if (labels.length === 1) {
                return this.$l10n.__(
                    numberInvalidEmailsAddresses > 1
                        ? `Plusieurs adresses emails renseignées dans le champ "${formattedLabels}" ne sont pas valides. Souhaitez-vous vérifier avant d’envoyer votre email ?`
                        : `Une adresse email renseignée dans le champ "${formattedLabels}" n’est pas valide. Souhaitez-vous vérifier avant d’envoyer votre email ?`,
                );
            }

            return this.$l10n.__(
                `Plusieurs adresses emails renseignées dans les champs "${formattedLabels}" ne sont pas valides. Souhaitez-vous vérifier avant d’envoyer votre email ?`,
            );
        },
        getRecipentsByType(type) {
            return (this.email?.addresses || [])
                .filter((item) => item.type === type)
                .map((item) => ({
                    name: item.name ?? item.email,
                    email: item.email,
                    related: item.related,
                }));
        },
        areRecipientsValid() {
            if (this.email.addresses.length === 0) {
                this.$pushToast({
                    type: 'error',
                    icon: true,
                    text: this.$l10n.__(
                        'Veuillez renseigner au moins un destinataire pour envoyer votre email',
                    ),
                    close: true,
                });
                return false;
            }

            const listAddressesNotValid = this.email.addresses.filter((item) => !item.isValid);
            const validEmailList = this.email.addresses.filter((item) => item.isValid);
            if (listAddressesNotValid.length > 0) {
                if (!validEmailList.length) {
                    this.$pushToast({
                        type: 'error',
                        icon: true,
                        text: this.$l10n.__(
                            'Veuillez renseigner au moins un destinataire pour envoyer votre email',
                        ),
                        close: true,
                    });
                    return false;
                }

                const numberInvalidEmailsAddresses = listAddressesNotValid.length;
                const emailsRecipientsTypeInvalid = [];
                for (const address of listAddressesNotValid) {
                    if (!emailsRecipientsTypeInvalid.includes(address.type)) {
                        emailsRecipientsTypeInvalid.push(address.type);
                    }
                }
                this.textDialogError = this.updateTextContent(
                    numberInvalidEmailsAddresses,
                    emailsRecipientsTypeInvalid,
                );
                this.shouldDisplayErrorDialog = true;
                return false;
            }
            const recipientsTo = this.getRecipentsByType('to');
            if (this.needOneMainRecipient && recipientsTo.length === 0) {
                this.shouldDisplayEmptyRecipientsWarningDialog = true;
                return false;
            }
            return true;
        },
    },
};
